import { Typography as AntdTypography } from "antd";
import { BaseType } from "antd/es/typography/Base";
import { CMP_PREFIX } from "@/base/constant";
import { cx } from "antd-style";
import type { GetProps } from "antd";

type ExtendedType = BaseType | "primary";
type SizeType = "default" | "middle" | "small";

export type TypographyProps = Partial<GetProps<typeof AntdTypography>>;
export type TitleProps = Partial<
  Omit<GetProps<typeof AntdTypography.Title>, "type"> & { type: ExtendedType }
>;
export type TextProps = Partial<
  Omit<GetProps<typeof AntdTypography.Text>, "type"> & {
    type: ExtendedType;
    size: SizeType;
  }
>;
export type ParagraphProps = Partial<GetProps<typeof AntdTypography.Paragraph>>;
export type LinkProps = Partial<
  GetProps<typeof AntdTypography.Link> & {
    size: SizeType;
  }
>;

export const typographyPrefixCls = `${CMP_PREFIX}-typography`;

export const Typography = ({ ...props }: TypographyProps) => {
  return <AntdTypography {...props} />;
};

export const Paragraph = ({ ...props }: ParagraphProps) => {
  return <AntdTypography.Paragraph {...props} />;
};

export const Title = ({ type, ...props }: TitleProps) => {
  const _type: any = type;

  return <AntdTypography.Title type={_type} {...props} />;
};

export const Text = ({
  type,
  size = "default",
  className,
  ...props
}: TextProps) => {
  const _type: any = type;

  return (
    <AntdTypography.Text
      type={_type}
      {...props}
      className={cx(className, `${typographyPrefixCls}-size-${size}`)}
    />
  );
};

export const Link = ({ size = "default", className, ...props }: LinkProps) => {
  return (
    <AntdTypography.Link
      {...props}
      className={cx(
        className,
        `${typographyPrefixCls}-size-${size}`,
        `${typographyPrefixCls}-link`,
      )}
    />
  );
};
